import { render, staticRenderFns } from "./SendToken.vue?vue&type=template&id=1ea0669f&scoped=true&"
import script from "./SendToken.vue?vue&type=script&lang=js&"
export * from "./SendToken.vue?vue&type=script&lang=js&"
import style0 from "./SendToken.vue?vue&type=style&index=0&id=1ea0669f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea0669f",
  null
  
)

export default component.exports